<template>
  <div class="wrapper">
    {{subject}}
  </div>
</template>

<script>
export default {
  props: {
    model: Object,
  },

  computed: {
    /**
     * @return {String}
     */
    subject() {
      return _.get(this.model, 'data.content.subject');
    },
  },
}
</script>

<style scoped>

</style>
